const menu = {
  key: "contacts",
  route: "/legacy/contacts",
  label: "sidebar.contacts",
  icon: "faAddressBook",
  group: "sales",
  order: 30,
  permission: "legacy.contacts.read"
};

export default menu;